import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { ACCOUNT_MAIN_TYPE_OPTIONS } from "../types/accountsTypes";

const AccountForm = ({ initialData, onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    accountCode: "",
    accountName: "",
    displayName: "",
    mainType: "asset",
    subType: "",
    normalBalance: "debit",
    status: "active",
    notes: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        accountCode: initialData.accountCode || "",
        accountName: initialData.accountName || "",
        displayName: initialData.displayName || "",
        mainType: initialData.mainType || "asset",
        subType: initialData.subType || "",
        normalBalance: initialData.normalBalance || "debit",
        status: initialData.status || "active",
        notes: initialData.notes || "",
      });
    }
  }, [initialData]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Account Code"
            value={formData.accountCode}
            onChange={(e) => handleChange("accountCode", e.target.value)}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Account Name"
            value={formData.accountName}
            onChange={(e) => handleChange("accountName", e.target.value)}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Display Name"
            value={formData.displayName}
            onChange={(e) => handleChange("displayName", e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel>Main Type</InputLabel>
            <Select
              value={formData.mainType}
              label="Main Type"
              onChange={(e) => handleChange("mainType", e.target.value)}
            >
              {ACCOUNT_MAIN_TYPE_OPTIONS.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Sub Type"
            value={formData.subType}
            onChange={(e) => handleChange("subType", e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel>Normal Balance</InputLabel>
            <Select
              value={formData.normalBalance}
              label="Normal Balance"
              onChange={(e) => handleChange("normalBalance", e.target.value)}
            >
              <MenuItem value="debit">Debit</MenuItem>
              <MenuItem value="credit">Credit</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Notes"
            value={formData.notes}
            onChange={(e) => handleChange("notes", e.target.value)}
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button type="submit" variant="contained" disabled={loading}>
          {initialData ? "Update Account" : "Create Account"}
        </Button>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default AccountForm;
